<template>
  <AppLayout>
    <VFlex>
      <h1 class="primary--text mb-4">
        {{ $nt('heading') }}
      </h1>
      <VCard flat>
        <VFlex>
          <AgencyOverviewStatements />
        </VFlex>
      </VCard>
    </VFlex>
  </AppLayout>
</template>

<script>
import AgencyOverviewStatements from '@/components/routes/agency/AgencyOverviewStatements'
export default {
  name: 'AgencyStatements',
  components: { AgencyOverviewStatements }
}
</script>
